import { RouteInterface } from '@/src/common/enums/routes'

export const MortgageEarnRoutes = {
  MortgageEarn: {
    route: '/main/(tabs)/home/earn-on-mortgage',
    name: 'Mortgage Earn',
    availableForDeepLinking: true,
    aliases: ['/main/home/earn-on-mortgage'],
  },
  MortgageEarnDocumentUpload: {
    route: '/main/(tabs)/home/earn-on-mortgage-document-upload',
    name: 'Mortgage Earn Document Upload',
    availableForDeepLinking: true,
    aliases: ['/main/home/earn-on-mortgage-document-upload'],
  },
} as const satisfies Record<string, RouteInterface>
